import Layout from '@/components/Layout';
import styles from './blog.module.scss';

import BlogPostEntry from '@/components/blog-post/BlogPostEntry';
import useConfig from '@/hooks/useConfig';
import Meta from '@/components/Meta';

import { getPosts } from '@/lib/posts';

export default function BlogPage({ posts }) {
  const { t } = useConfig();

  return (
    <Layout>
      <Meta title={t('blog.meta.title')} description={t('blog.meta.description')} />

      <div className={styles.blogPosts}>
        {(!posts || !posts.length) && <p>There are no blog posts right now. Please check back later!</p>}
        {posts.map((post, idx) => (
          <div key={idx} className={styles.listEntry}>
            <BlogPostEntry post={post} listEntry={true} />
          </div>
        ))}
      </div>

    </Layout>
  );
}

export async function getStaticProps(ctx) {
  const posts = await getPosts();

  return {
    props: { posts }
  };
}
